// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function CardWithImage({ image, heading, description, subDesc }) {
  const imageTemplate = <MKBox component="img" src={image} width="100%" />;

  return (
    <MKBox
      position="relative"
      bgColor="white"
      borderRadius="xl"
      shadow="md"
      sx={{
        overflow: "hidden",
        transform: "perspective(999px) rotateX(0deg) translate3d(0, 0, 0)",
        transformOrigin: "50% 0",
        backfaceVisibility: "hidden",
        willChange: "transform, box-shadow",
        transition: "transform 200ms ease-out",

        "&:hover": {
          transform: "perspective(999px) rotateX(7deg) translate3d(0px, -4px, 5px)",
        },
      }}
    >
      {image && imageTemplate}
      {heading && (
        <MKBox lineHeight={1} mx={2} mb={2}>
          <MKTypography variant="h6" fontWeight="bold">
            {heading}
          </MKTypography>
          <MKTypography
            variant="button"
            component="p"
            fontWeight="regular"
            color="secondary"
            style={{ "text-align": "justify" }}
            mt={1}
          >
            {description}
          </MKTypography>
          {subDesc &&
            subDesc.map(({ text, type, li }, index) => (
              <MKTypography
                variant="button"
                component={type}
                fontWeight="regular"
                color="secondary"
                style={{ "text-align": "justify" }}
                mt={1}
                key={index}
                mx={type === "ul" ? 2 : 0}
              >
                {!li && text}
                {li && li.map((text, index) => <li key={index}>{text}</li>)}
              </MKTypography>
            ))}
        </MKBox>
      )}
    </MKBox>
  );
}

// Setting default props for the ExampleCard
CardWithImage.defaultProps = {
  image: "",
  heading: "",
  description: "",
};

// Typechecking props for the ExampleCard
CardWithImage.propTypes = {
  image: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  subDesc: PropTypes.array,
};

export default CardWithImage;
